export enum QueryKey {
  Agreement = 'agreement',
  Agreements = 'agreements',
  Milestones = 'milestones',
  MilestoneExternalId = 'milestone-external-id',
  AuthenticatedTenantUser = 'authenticated-tenant-user',
  AuthenticatedRootAdmin = 'authenticated-root-admin',
  TenantUserChallenge = 'tenant-user-challenge',
  RootAdminChallenge = 'root-admin-challenge',
  Disputes = 'disputes',
  DisputeSignature = 'dispute-signature',
  TenantUsers = 'tenant-users',
  TenantBalance = 'tenant-balance',
  Invite = 'invite',
  RootAdminInvite = 'root-admin-invite',
  Transactions = 'transactions',
  RootAdminSignupStatus = 'root-admin-signup-status',
  Organizations = 'organizations',
  RootAdmins = 'root-admins',
  ProofOfDeliveryUrl = 'proof-of-delivery-url',
  Organization = 'organization',
  BridgeConfig = 'bridge-config',
  ApiKey = 'api-key',
  Me = 'me',
  SharedBridgeWebhook = 'shared-bridge-webhook',
  PlatformBridgeConfig = 'platform-bridge-config',
  TenantWebhook = 'tenant-webhook',
  ProviderConfigs = 'provider-configs',
  ProviderEligibility = 'provider-eligibility',
  OrganisationProviderConfigs = 'organisation-provider-configs',
  Documents = 'documents',
  DownloadUrl = 'download-url',
}
